import React, { memo } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { formatNumber } from "helpers/getNumberFormats";
import { InvoiceGrid } from "./styled-components";
import {
  ROW_COLUMNS,
  ROW_GRID_COLUMNS,
  accentLabelStyle,
  auxControlStyle,
  labelCellStyle,
  labelTextStyle,
} from "./invoiceLayout";

/**
 * Fila de totales: etiqueta, Total $ y Total Lt.
 *
 * Comparte la rejilla de 24 columnas de CreLicenseRow -- contenedor incluido --
 * para que las dos columnas de importes queden alineadas en toda la pantalla.
 * La casilla Manual, cuando aplica, vive dentro de la columna de la etiqueta.
 */
export const GridGN4Invoice = memo(
  ({
    data = {},
    title = "",
    hint = "",
    accent = false,
    manual = false,
    onToggleManual,
    onChangeAmount,
    onChangeQuantity,
  }) => {
    const editable = manual && !!onToggleManual;

    return (
      <Grid item xs={12} mt={1} mb={1}>
        <Grid
          container
          spacing={1}
          alignItems="center"
          columns={ROW_GRID_COLUMNS}
        >
          <InvoiceGrid item xs={ROW_GRID_COLUMNS} sm={ROW_COLUMNS.label}>
            <Box sx={labelCellStyle}>
              <Typography sx={accent ? { ...labelTextStyle, ...accentLabelStyle } : labelTextStyle}>
                {title}
              </Typography>

              {hint && (
                <Typography variant="caption" color="text.secondary" data-testid="grid-hint">
                  {hint}
                </Typography>
              )}

              {onToggleManual && (
                <FormControlLabel
                  sx={auxControlStyle}
                  control={
                    <Checkbox
                      color="primary"
                      size="small"
                      checked={manual}
                      onChange={onToggleManual}
                    />
                  }
                  label="Manual"
                  labelPlacement="start"
                />
              )}
            </Box>
          </InvoiceGrid>

          <InvoiceGrid item xs={ROW_GRID_COLUMNS} sm={ROW_COLUMNS.totalAmount}>
            <TextField
              fullWidth
              size="small"
              type="text"
              label="Total $"
              value={
                editable ? data?.total ?? 0 : formatNumber({ input: data?.total })
              }
              variant="outlined"
              disabled={!editable}
              onChange={onChangeAmount}
            />
          </InvoiceGrid>

          <InvoiceGrid
            item
            xs={ROW_GRID_COLUMNS}
            sm={ROW_COLUMNS.totalQuantity}
          >
            <TextField
              fullWidth
              size="small"
              type="text"
              label="Total Lt"
              value={
                editable
                  ? data?.quantity ?? 0
                  : formatNumber({ input: data?.quantity })
              }
              variant="outlined"
              disabled={!editable}
              onChange={onChangeQuantity}
            />
          </InvoiceGrid>
        </Grid>
      </Grid>
    );
  },
);
